import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { AnredeArtApi } from './InterfacesAnredeArtApi';
import { PhoneApi } from './PersonPhoneApi';
import { MglArtApi } from './PersonMglArtApi';
import { AddressApi } from './PersonAddressApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.Mitgliedschaft.Partner
 * Daten eines (Ehe-) Partners für die Mitgliedschaftsanlage
 * Endpoints: /api/mitgliedschaft, /api/mitgliedschaft/check24ev, /api/mitgliedschaft/erweitern, /api/mitgliedschaft/finanzdienste/kreditkarte, /api/mitgliedschaft/finanzdienste/modulkreditkarte, /api/mitgliedschaft/finanzdienste/autokredit, /api/mitgliedschaft/versicherungen/auto, /api/mitgliedschaft/profiwerber/agw, /api/mitgliedschaft/erweitern/profiwerber/agw
 */
export class PartnerApi extends BaseApiModel {
	constructor(initialProperties?: Partial<PartnerApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected anrede: AnredeArtApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Interfaces.AnredeArt
	 */
	get Anrede(): AnredeArtApi {
		return this.anrede;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Interfaces.AnredeArt
	 */
	set Anrede(value: AnredeArtApi) {
		this.anrede = value;
	}

	protected titel: string;
	/**
	 * Description: Titel
	 * APIL Type: string
	 */
	get Titel(): string {
		return this.titel;
	}

	/**
	 * Description: Titel
	 * APIL Type: string
	 */
	set Titel(value: string) {
		this.titel = value;
	}

	protected vorname: string;
	/**
	 * Description: Vorname
	 * APIL Type: string
	 */
	get Vorname(): string {
		return this.vorname;
	}

	/**
	 * Description: Vorname
	 * APIL Type: string
	 */
	set Vorname(value: string) {
		this.vorname = value;
	}

	protected nachname: string;
	/**
	 * Description: Nachname
	 * APIL Type: string
	 */
	get Nachname(): string {
		return this.nachname;
	}

	/**
	 * Description: Nachname
	 * APIL Type: string
	 */
	set Nachname(value: string) {
		this.nachname = value;
	}

	protected geburtsdatum: string;
	/**
	 * Description: Geburtsdatum
	 * APIL Type: date-time
	 */
	get Geburtsdatum(): string {
		return this.geburtsdatum;
	}

	/**
	 * Description: Geburtsdatum
	 * APIL Type: date-time
	 */
	set Geburtsdatum(value: string) {
		this.geburtsdatum = value;
	}

	protected email: string;
	/**
	 * Description: E-Mail-Adresse
	 * APIL Type: string
	 */
	get Email(): string {
		return this.email;
	}

	/**
	 * Description: E-Mail-Adresse
	 * APIL Type: string
	 */
	set Email(value: string) {
		this.email = value;
	}

	protected telefon: PhoneApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	get Telefon(): PhoneApi {
		return this.telefon;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	set Telefon(value: PhoneApi) {
		this.telefon = value;
	}

	protected tarif: MglArtApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.MglArt
	 */
	get Tarif(): MglArtApi {
		return this.tarif;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.MglArt
	 */
	set Tarif(value: MglArtApi) {
		this.tarif = value;
	}

	protected tarifmerkmal: string;
	/**
	 * Description: Tarifmerkmal für den Partner (PAR)
	 * APIL Type: string
	 */
	get Tarifmerkmal(): string {
		return this.tarifmerkmal;
	}

	/**
	 * Description: Tarifmerkmal für den Partner (PAR)
	 * APIL Type: string
	 */
	set Tarifmerkmal(value: string) {
		this.tarifmerkmal = value;
	}

	protected hatAbweichendeAnschrift: boolean;
	/**
	 * Description: Flag welches angibt ob die abweichende Anschrift herangezogen wird.
Wird nur die Adressergänzung befüllt kann dieses auf false stehen.
	 * APIL Type: boolean
	 */
	get HatAbweichendeAnschrift(): boolean {
		return this.hatAbweichendeAnschrift;
	}

	/**
	 * Description: Flag welches angibt ob die abweichende Anschrift herangezogen wird.
Wird nur die Adressergänzung befüllt kann dieses auf false stehen.
	 * APIL Type: boolean
	 */
	set HatAbweichendeAnschrift(value: boolean) {
		this.hatAbweichendeAnschrift = value;
	}

	protected anschrift: AddressApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Address
	 */
	get Anschrift(): AddressApi {
		return this.anschrift;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Address
	 */
	set Anschrift(value: AddressApi) {
		this.anschrift = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): PartnerApi {
		return AppUtils.Helper.createFromMap(dataObject, PartnerApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'telefon':
					return PhoneApi.createFromObject(value);
				case 'anschrift':
					return AddressApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Anrede = this.anrede;
		result.Titel = this.titel;
		result.Vorname = this.vorname;
		result.Nachname = this.nachname;
		result.Geburtsdatum = this.geburtsdatum;
		result.Email = this.email;
		if (this.telefon) {
			result.Telefon = this.telefon.toRequestObject();
		}
		result.Tarif = this.tarif;
		result.Tarifmerkmal = this.tarifmerkmal;
		result.HatAbweichendeAnschrift = this.hatAbweichendeAnschrift;
		if (this.anschrift) {
			result.Anschrift = this.anschrift.toRequestObject();
		}
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}